import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { useCurrentModule } from '../components';
import { useUpgradeRecommendation } from './useUpgradeRecommendation';
export const useUpgradeRecommendedProduct = () => {
  var _catalog$recommendedP, _offering$products;
  const module = useCurrentModule();
  const {
    data,
    requestId,
    isFallback
  } = useUpgradeRecommendation();
  const {
    data: offering
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: catalog
  } = PremiumPurchasePlatformModule.SDK.ApiClient.groupBy('ProductCardList').hooks.useGroupedGetProductCardList(p3Context);
  const pickFamilyId = (data == null ? void 0 : data.plan.recommendedProductFamilyId) ?? (isFallback ? catalog == null || (_catalog$recommendedP = catalog.recommendedProductFamily) == null ? void 0 : _catalog$recommendedP.productFamilyId : undefined);
  const product = pickFamilyId ? offering == null || (_offering$products = offering.products) == null ? void 0 : _offering$products.find(candidate => candidate.productFamilyId === pickFamilyId) : undefined;
  return {
    productId: product == null ? void 0 : product.productId,
    productName: product == null ? void 0 : product.name,
    siteName: data == null ? void 0 : data.siteName,
    requestId,
    cycleId: product != null && product.productFamilyId ? data == null ? void 0 : data.cycles.byProductFamilyId[product.productFamilyId] : undefined,
    isFallback
  };
};
//# sourceMappingURL=useUpgradeRecommendedProduct.js.map